module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAC1QTFRFDxAQh4eHw8PDS0xMLS4uaWpq0tLS8PDwlpaW4eHhWltbHh8fPD09eHl5////Dw6pwAAAAA90Uk5T//////////////////8A1NyYoQAAAIhJREFUeNrslEsOgCAMBQuUv3L/41pCjAGFdqUbZ/UCk9DwCOAQGNBBBhaET9hjVJyjCsFZsUqekbxEEh0Hwfvw3jUZRRgKtgZqK2itFU4G1zWALQ27kFI5SXPpIq4kmqiFbS7VLXubqpfatbqxhWHwVsJaMs99/pJM6h8d9mvvkyWK5Ds8BBgAxcEOT7rHHNgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Home/img/In-Black-0p5in-R.png
// module id = 87
// module chunks = 0